interface RootState {
  EmployeeInfo: {
    employeesInfo: any[];
  };
}

// eslint-disable-next-line import/prefer-default-export
export const employeesInfo = (state: RootState) => state.EmployeeInfo.employeesInfo;
